import { motion, AnimatePresence } from "framer-motion";
import { useRheaLoading } from "@/lib/ui/RheaLoadingContext";
import { shouldShowColdStartBanner } from "@/lib/ui/coldStartVisibility";

// Marketplace Loading & Launch Polish V1 — this banner's show/hide timing
// (a request taking longer than a couple of seconds) is unchanged; only the
// copy changed. The rendered text must never name our hosting infrastructure
// or a slow warm-up delay — neutral marketplace-discovery language only,
// same family as the rest of Experiences' loading copy.
//
// Marketplace Search Language & Loading V1, task 1: this banner and the
// full-screen Rhea loading overlay are two independent mechanisms (the
// overlay is driven by startLoading()/RheaLoadingProvider; this banner by
// fetchApi()'s 2s slow-response timer in lib/api.ts) that both fire during
// the same search — that's the duplicate-loader bug. Rather than coordinate
// the two timers, this component simply defers to the overlay: whenever the
// overlay is on screen, this banner never renders, so a search only ever
// shows one loading surface. It remains available for slow requests that
// don't show the overlay (e.g. background lookups).
export function ColdStartBanner({ visible }: { visible: boolean }) {
  const { isOverlayVisible } = useRheaLoading();
  const shouldShow = shouldShowColdStartBanner(visible, isOverlayVisible);
  return (
    <AnimatePresence>
      {shouldShow && (
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          className="fixed top-16 left-0 right-0 z-40 text-center py-2 px-4 text-sm bg-accent/80 backdrop-blur"
          style={{ color: "#E8194B" }}
        >
          Buscando experiencias disponibles...
        </motion.div>
      )}
    </AnimatePresence>
  );
}
